import React, { ReactNode } from "react";

import {
  GridIcon as Grid,
  ListIcon as List,
  TreeIcon as Tree
} from "@packages/ds";

import * as S from "./Toggle.styles";

export enum Type {
  icon = "icon",
  text = "text"
}
export enum Layout {
  grid = "grid",
  list = "list",
  tree = "tree",
  custom = "custom"
}

export type Props = {
  toggleType: keyof typeof Type;
  layout?: keyof typeof Layout | undefined;
  text?: ReactNode;
  customIcon?: ReactNode;
  disabled?: boolean | undefined;
  pressed?: boolean | undefined;
  onPressedChange: (pressed: boolean) => void;
};

const getIcon = (layout: string | undefined, customIcon?: ReactNode) => {
  switch (layout) {
    case "grid":
      return <Grid />;
    case "tree":
      return <Tree />;
    case "list":
      return <List />;
    case "custom":
      return customIcon;
  }
};

const Toggle = ({
  toggleType = "text",
  disabled,
  text,
  layout,
  customIcon,
  onPressedChange,
  pressed,
  ...props
}: Props) => {
  return (
    <S.Layout
      {...props}
      $toggleType={toggleType}
      disabled={disabled}
      pressed={pressed}
      onPressedChange={onPressedChange}
      aria-label="toggle-layout"
    >
      {toggleType === "text" ? text : getIcon(layout, customIcon)}
    </S.Layout>
  );
};

export default Toggle;
